import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';

/**
 * Homepage class.
 */
export default class ProductCard extends withIntersectionObserver(Base, {
  threshold: 0.2,
}) {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'ProductCard',
    refs: ['picture'],
    options: {
      index: {
        type: Number,
        default: 0,
      },
    },
  };

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.showProduct();
    }
  }

  /**
   *
   */
  showProduct() {
    if (this.$el.classList.contains('loaded') || this.$el.classList.contains('inview')) {
      return;
    }
    this.$el.classList.add('inview');
    this.$el.classList.add('pointer-events-none');

    gsap.fromTo(
      this.$el,
      {
        opacity: 0,
        y: -30,
      },
      {
        opacity: 1,
        y: 0,
        delay: this.$options.index * 0.1,
        duration: 1.5,
        ease: 'power4.out',
        clearProps: 'transform',
        onStart: () => {
          window.dispatchEvent(new Event('resize')); // Fix slider from studiometa/ui issue.
          this.$el.classList.remove('pointer-events-none');
        },
        onComplete: () => {
          this.$el.classList.add('loaded');
        },
      },
    );
  }
}
